import api from "./api";

const transferService = {
    transfer: (jwttoken, token, qtd, toUserId, password) =>
        api.post(`/transfer`, {
            token, 
            qtd, 
            toUserId,
            password
        }, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
};

export default transferService;